import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Image,
  Flex,
  Box,
  Tooltip,
  Text,
  FormControl,
  FormLabel,
  ModalHeader,
  Stack,
  useDisclosure,
  Avatar,
} from '@chakra-ui/react'
import download from "@/assets/download.svg"
import share from "@/assets/share.svg"
import like from "@/assets/like_blue.svg"
import collect from "@/assets/star_blue.svg"
import { ReactSVG } from 'react-svg'
import "../publish/index.css"
import { useGetContentQuery } from "@/services/api/endpoints/content"
import InviteModal from '../inviteModal';
import PubContent from '../publish/content';
import ContentComment from './contentcomment'
import { Content } from '@/types/content'
import { useCallback } from 'react';
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  contentId: string;
  onOneClick: () => void;
}

const ContentDetail = (props: Props) => {
  const { data } = useGetContentQuery(props.contentId);
  const user = useSelector(selectUser);
  const shareDisclosure = useDisclosure()
  const linkSrc = 'https://www/aldgptai.com?rand_code='+user.rand_code;
  const handleOnekey = () => {

  }

  const handleDownLoad = useCallback(async () => {
    if (!data) {
      return;
    }
    try {
      const response = await fetch(data.image_url as string);
      const blob = await response.blob();
      const link = document.createElement("a") as HTMLAnchorElement;
      link.href = URL.createObjectURL(blob);
      link.download = generateRandomCode(9) + ".png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error fetching the image", error);
    }
  }, [data]);

  const generateRandomCode = (length: number): string => {
    let code = "";
    for (let j = 0; j < length; j++) {
      code += Math.floor(Math.random() * 10); // 生成 0-9 之间的随机数
    }
    return code;
  };
  

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="6xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader></ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {
            data && <Flex>
              <Flex padding="20px" border="1px solid #DCE0EB" alignItems={"center"} justifyContent={"center"} flex={1}>
                <Image src={data.image_url} />
              </Flex>
              <Box p="20px" overflow="auto" maxHeight="600px" flex={1}>
                <Flex>
                  {/* 需要判断 */}
                  <Tooltip label='下载'>
                    <Box cursor="pointer" onClick={handleDownLoad}><ReactSVG src={download} /></Box>
                  </Tooltip>
                  <Tooltip label='分享'>
                    <Box cursor="pointer" ml="30px" mr="30px" onClick={shareDisclosure.onOpen}><ReactSVG src={share} />
                    </Box>
                  </Tooltip>
                  <InviteModal isOpen={shareDisclosure.isOpen} onClose={shareDisclosure.onClose} bannerSrc={data.image_url} linkSrc={linkSrc} />
                </Flex>
                <Box>
                  <Stack direction={"row"} mt="20px"> 
                    <Avatar size="sm" mr="10px" src={`/api/v4/users/${data.user_id}/image`} />
                    <Text>{data.nickname ? data.nickname : data.username}</Text>
                  </Stack>
                  <Box mt="20px" mb="20px">
                    <Text fontSize={"22px"}>{data.content_name}</Text>
                    <Text fontSize={"14px"} mt="10px">{data.content_intro}</Text>
                  </Box>
                  <FormControl>
                    <FormLabel>作品信息</FormLabel>
                    <PubContent pubContent={data} />
                  </FormControl>
                  <FormControl mt="30px">
                    <FormLabel>评论</FormLabel>
                    <ContentComment contentId={props.contentId} />
                  </FormControl>
                  <Flex mt="20px">
                    <Stack align={"center"}>
                      <ReactSVG src={like} />
                      <Text>{data.like_num}</Text>
                    </Stack>
                    <Stack ml="30px" align={"center"}>
                      <ReactSVG src={collect} />
                      <Text>{data.collect_num}</Text>
                    </Stack>
                    <button type='button' className='btn-grad' onClick={props.onOneClick}>一键同款</button>
                  </Flex>
                </Box>
              </Box>
            </Flex>
          }
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ContentDetail

